/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import { Box, Button, makeStyles, Typography } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { useTranslation } from 'react-i18next';
import RemoveOrganizationDialog from '../../../components/organization/RemoveOrganizationDialog';
import RemoveOrganizationResultDialog from '../../../components/organization/RemoveOrganizationResultDialog';
import useRemoveOrganization from '../../../redux/features/organization/remove/useRemoveOrganization';

const useStyles = makeStyles(theme => ({
  container: {
    marginTop: theme.spacing(4),
  },
  description: {
    fontSize: '1.2rem',
    fontWeight: '400',
    maxWidth: '35rem',
    marginTop: theme.spacing(1),
  },
  button: {
    marginTop: theme.spacing(2),
  },
}));

function DeleteOrganization() {
  const { t } = useTranslation();
  const classes = useStyles();

  const {
    removeDialog,
    organizationId,
    valiateRemoveOrganization,
    onRemoveOrgConfirm,
    onToggleRemoveDialog,
    resultDialog,
    onToggleResultDialog,
    error,
  } = useRemoveOrganization();

  return (
    <Box className={classes.container}>
      <Typography variant="h1" component="h1" color="textPrimary" gutterBottom>
        {t('user.management.delete.organization')}
      </Typography>
      <Typography variant="h6" color="textSecondary" gutterBottom className={classes.description}>
        {t('user.management.delete.organization.description')}
      </Typography>
      <Button
        data-testid="editUserRoles"
        name="editUserRoles"
        type="submit"
        variant="contained"
        color="default"
        className={classes.button}
        startIcon={<CloseIcon />}
        onClick={valiateRemoveOrganization}
      >
        {t('user.management.delete.organization.button')}
      </Button>
      {removeDialog.open && (
        <RemoveOrganizationDialog
          organizationId={organizationId}
          error={error}
          dialog={removeDialog}
          toggleDialog={onToggleRemoveDialog}
          onSubmit={onRemoveOrgConfirm}
        />
      )}

      {resultDialog.open && (
        <RemoveOrganizationResultDialog
          resultDialog={resultDialog}
          onToggleResultDialog={result => onToggleResultDialog(result)}
          result={error}
        />
      )}
    </Box>
  );
}

export default DeleteOrganization;
